
import { oz } from '@weft/utils';
import { created } from '../../utils/created';
import { CommitmentSchema } from '../commitment';
import { ProductVariantSchema } from '../product-variant/product-variant-schema';
import { NewProductSchema } from './new-product-schema';

export const ProductSchema = created(NewProductSchema).extend({
  variants: oz.array(ProductVariantSchema).min(1),
  commitment: CommitmentSchema.nullable(),
}).openapi('Product');

export type Product = oz.infer<typeof ProductSchema>;